module.exports = __webpack_public_path__ + "img/new_event_coming_soon.4c8ef70a.png";